import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { getAuth } from 'firebase/auth';
import { io } from 'socket.io-client';
import ChatThread from './ChatThread';
import '../styles/Messages.css';

const socket = io('https://sync-api-troz.onrender.com');

const Messages = () => {
  const [messages, setMessages] = useState([]);
  const [conversations, setConversations] = useState([]);
  const [selectedConversation, setSelectedConversation] = useState(null);
  const [currentUserArtistName, setCurrentUserArtistName] = useState('');
  const auth = getAuth();

  useEffect(() => {
    const user = auth.currentUser;
    if (user) {
      socket.emit('join', user.uid);

      socket.on('newMessage', (message) => {
        alert(`${message.sender.artistName} wants to collaborate with you!`);
        setMessages((prevMessages) => [...prevMessages, message]);
      });

      socket.on('collaborationAccepted', (conversation) => {
        alert('A collaboration offer was accepted! A new chat is available.');
        setConversations((prevConversations) => [...prevConversations, conversation]);
      });

      const fetchMessages = async () => {
        try {
          const response = await axios.get(`https://sync-api-troz.onrender.com/api/messages?firebaseUid=${user.uid}`);
          setMessages(response.data);
        } catch (error) {
          console.error('Error fetching messages:', error);
        }
      };

      const fetchConversations = async () => {
        try {
          const response = await axios.get(`https://sync-api-troz.onrender.com/api/conversations?userId=${user.uid}`);
          setConversations(response.data);
        } catch (error) {
          console.error('Error fetching conversations:', error);
        }
      };

      const fetchCurrentUserArtistName = async () => {
        try {
          const response = await axios.get(`https://sync-api-troz.onrender.com/api/users/firebase/${user.uid}`);
          setCurrentUserArtistName(response.data.artistName);
        } catch (error) {
          console.error('Error fetching current user:', error);
        }
      };

      fetchMessages();
      fetchConversations();
      fetchCurrentUserArtistName();
    }

    return () => {
      socket.off('newMessage');
      socket.off('collaborationAccepted');
    };
  }, [auth]);

  const handleAcceptCollaboration = async (messageId) => {
    try {
      await axios.post('https://sync-api-troz.onrender.com/api/messages/accept', {
        messageId,
        userId: auth.currentUser.uid,
      });
      alert('Collaboration accepted!');
      setMessages((prevMessages) =>
        prevMessages.map((msg) =>
          msg._id === messageId ? { ...msg, status: 'accepted' } : msg
        )
      );
    } catch (error) {
      console.error('Error accepting collaboration:', error);
      alert('Failed to accept collaboration.');
    }
  };

  const handleDenyCollaboration = async (messageId) => {
    try {
      await axios.post('https://sync-api-troz.onrender.com/api/messages/deny', {
        messageId,
        userId: auth.currentUser.uid,
      });
      alert('Collaboration denied.');
      setMessages((prevMessages) =>
        prevMessages.map((msg) =>
          msg._id === messageId ? { ...msg, status: 'denied' } : msg
        )
      );
    } catch (error) {
      console.error('Error denying collaboration:', error);
      alert('Failed to deny collaboration.');
    }
  };

  if (selectedConversation) {
    return (
      <ChatThread
        conversationId={selectedConversation._id}
        participants={selectedConversation.participants.map((p) => p.artistName)}
        onClose={() => setSelectedConversation(null)}
      />
    );
  }

  return (
    <div className="messages-page">
      <div className="messages-container">
        <h1 className="messages-header">Messages</h1>

        <div className="messages-conversation-list">
          {/* <h2 className="messages-section-heading">Conversations</h2> */}
          {conversations.length > 0 ? (
            conversations.map((conversation) => {
              const otherParticipants = conversation.participants
                .filter((p) => p.artistName !== currentUserArtistName)
                .map((p) => p.artistName)
                .join(', ');

              return (
                <div
                  key={conversation._id}
                  className="messages-conversation-item"
                  onClick={() => setSelectedConversation(conversation)}
                >
                  <div className="messages-item-details">
                    <h3 className="messages-item-title">{otherParticipants}</h3>
                    {/* <p className="messages-item-meta">
                      {conversation.lastMessage?.content || 'No messages yet'}
                    </p> */}
                  </div>
                </div>
              );
            })
          ) : (
            <p className="messages-no-conversations">No active conversations.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Messages;